import * as runnersApi from "app/api/runnersApi";
import isEmpty from "lodash/isEmpty";
import store from "../store/store";
export class PublicViewHelper {
  /**
   * Fetches prices for runners in the bet slip for public view.
   */
  static fetchPricesForRunnersInBetslip() {
    const betSlipList = store.getState().betSlipListModel.betSlipList;

    if (isEmpty(betSlipList)) return;

    return runnersApi
      .getPricesForRunnersInBetslip()
      .then(resp => {
        // added update for changed function name in betslipListModel
        store.dispatch.betSlipListModel.updateSingleBetSlipPrices(resp);
        store.dispatch.multiplesBetSlipListModel.updateLegOddsFromPricesFetch(
          resp
        );
      })
      .catch(error => {
        throw error;
      });
  }
}
